import type { Writable } from 'svelte/store';
import { writable } from 'svelte/store';

type ViewportOptions = {
	isMobile?: boolean;
	isTablet?: boolean;
	isDesktop?: boolean;
};

const viewportOptionsDefault: ViewportOptions = {
	isMobile: undefined,
	isTablet: undefined,
	isDesktop: undefined
};

const viewportStore = (options: ViewportOptions): Writable<ViewportOptions> => {
	return writable<ViewportOptions>(options);
};

export const viewport = viewportStore(viewportOptionsDefault);
